<schir-int-client-button-round (click)="openCreateVorgangDialog()" popup="dialog" materialIcon="add"
                               data-test-id="create-vorgang-button" toolTip="Vorgang zu Verfahren anlegen" cssClass="{{cssClass}}"/>
